import { render, staticRenderFns } from "./Configurar.vue?vue&type=template&id=33443d88"
import script from "./Configurar.vue?vue&type=script&lang=js"
export * from "./Configurar.vue?vue&type=script&lang=js"
import style0 from "./Configurar.vue?vue&type=style&index=0&id=33443d88&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports